import * as React from 'react';
import { MenuConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { ELEMENT_V_ALIGN_DIS } from '@editor/src/img/pageIndex';
import i18n from '@i18next/i18n';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.ALIGN_DISTRIBUTE_VERTICALLY,
    icon: ELEMENT_V_ALIGN_DIS,
    content: i18n.t('纵向分布'),
    twdConfig: {
        action: TDWActionType.ARRANGE,
        ver5: ActionType.ALIGN_DISTRIBUTE_VERTICALLY,
    },
};

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: MenuKey.ALIGN_DISTRIBUTE_VERTICALLY,
        content: i18n.t<string>('纵向分散'),
        tooltip: i18n.t<string>('纵向分散'),
    },
];
